import { i as v } from "./reactive-element-CzWTglSF.js";
import { html as i } from "../beacon-html.d/index.js";
import "./lit-element-sPTOReu4.js";
import { ifDefined as c } from "../beacon-if-defined.d/index.js";
import { when as u } from "../beacon-when.d/index.js";
import { B as p } from "./button-base-BSh_aZ7k.js";
import { m as h } from "./mixin-DsSIi_3b.js";
import { m as y, a as m } from "./lifecycle-decorators-Cg3csm0R.js";
const g = {
  beaconTagName: "beacon-popover",
  DATA_METRICS_LOCATION_POPOVER: "PU",
  DATA_METRICS_LOCATION_BODY: "BDY"
}, f = v`:host([motion-state=enabled]) .icon-button{--button-base-transition-duration: var(--beacon-reference-motion-duration-5);--scale-value: 1.1;transition-property:var(--button-base-transition-property),transform}:host([motion-state=enabled]) .icon-button:is(:hover,:active){transform:scale(var(--scale-value))}:host([motion-state=enabled]) .icon-button:is(:hover,:active) .contents{transform:scale(calc(1 / var(--scale-value)))}`;
var k = Object.getOwnPropertyDescriptor, _ = (e, r, t, s) => {
  for (var o = s > 1 ? void 0 : s ? k(r, t) : r, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(o) || o);
  return o;
};
function w(e) {
  let r = class extends e {
    static get IconButtonMotionStyles() {
      return [f];
    }
  };
  return r = _([
    y("IconButtonMotion")
  ], r), r;
}
const $ = v`.visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}:host{display:var(--override-icon-button-display, inline-block)}.icon-button{--active-bg: var(--beacon-system-color-background-primary-pressed);--active-border: var(--beacon-system-color-border-secondary-pressed);--active-icon: var(--beacon-system-color-icon-secondary-pressed);--bg-color: var(--beacon-system-color-background-primary);--border-color: var(--beacon-system-color-border-secondary);--border-width: var(--beacon-system-width-border-mini);--default-size: var(--beacon-reference-space-9);--disabled-bg: var(--beacon-system-color-background-primary-inactive);--disabled-border: var(--beacon-system-color-border-secondary-inactive);--disabled-icon: var(--beacon-system-color-icon-primary-inactive);--hover-bg: var(--beacon-system-color-background-primary-hover);--hover-border: var(--beacon-system-color-border-secondary-hover);--hover-icon: var(--beacon-system-color-icon-secondary-hover);--icon-color: var(--beacon-system-color-icon-primary);align-items:center;background-color:var(--override-icon-button-bg-color, var(--bg-color));block-size:var(--override-icon-button-wrapper-block-size, var(--beacon-reference-space-10));border:var(--border-width) solid var(--border-color);border-radius:var(--override-icon-button-border-radius, var(--beacon-system-radius-corner-circle));box-shadow:var(--override-icon-button-box-shadow, initial);color:var(--override-icon-button-color, var(--beacon-host-override-icon-button-color, var(--icon-color)));cursor:pointer;display:inline-flex;inline-size:var(--override-icon-button-wrapper-inline-size, var(--beacon-reference-space-10));justify-content:center;outline-offset:var(--override-icon-button-outline-offset);position:relative;padding:var(--override-icon-button-padding, 0)}.icon-button .contents{align-items:inherit;display:inherit;justify-content:inherit;position:inherit}.icon-button[aria-disabled=true]{--icon-color: var(--disabled-icon);background-color:var(--disabled-bg);border-color:var(--disabled-border);color:var(--disabled-icon);cursor:not-allowed}.icon-button svg,.icon-button [beacon-tag-name=beacon-icon]{position:absolute}.icon-button:-webkit-direct-focus{outline:-webkit-focus-ring-color auto 0}.icon-button:hover:not([aria-disabled=true]){--icon-color: var(--hover-icon);background-color:var(--hover-bg);border-color:var(--hover-border);color:var(--hover-icon)}.icon-button:active:not([aria-disabled=true]){--icon-color: var(--active-icon);background-color:var(--active-bg);border-color:var(--active-border);color:var(--active-icon)}.icon-button.primary{--active-bg: var(--override-icon-button-bg-color-pressed, var(--default-active-bg));--active-icon: var(--beacon-system-color-icon-primary);--bg-color: var(--override-icon-button-bg-color, var(--default-bg));--default-active-bg: var(--beacon-system-color-background-primary-pressed);--default-bg: var(--beacon-system-color-background-primary);--default-hover-bg: var(--beacon-system-color-background-primary-hover);--disabled-bg: var(--beacon-system-color-background-primary-inactive);--disabled-icon: var(--beacon-system-color-icon-primary-inactive);--hover-bg: var(--override-icon-button-bg-color-hover, var(--default-hover-bg));--hover-icon: var(--beacon-system-color-icon-primary);--icon-color: var(--beacon-system-color-icon-primary);border:0}.icon-button.secondary{--active-bg: var(--beacon-system-color-background-secondary-pressed);--active-border: var(--beacon-system-color-border-secondary-pressed);--active-icon: var(--beacon-system-color-icon-secondary-pressed);--bg-color: transparent;--border-color: var(--beacon-system-color-border-secondary);--disabled-bg: transparent;--disabled-border: var(--beacon-system-color-border-secondary-inactive);--disabled-icon: var(--beacon-system-color-icon-secondary-inactive);--hover-bg: var(--beacon-system-color-background-secondary-hover);--hover-border: var(--beacon-system-color-border-secondary-hover);--hover-icon: var(--beacon-system-color-icon-secondary-hover);--icon-color: var(--beacon-system-color-icon-secondary)}.icon-button.tertiary{--active-bg: var(--beacon-system-color-background-tertiary-pressed);--active-icon: var(--beacon-system-color-icon-tertiary-pressed);--bg-color: transparent;--default-hover-bg: var(--beacon-system-color-background-tertiary-hover);--default-hover-icon: var(--beacon-system-color-icon-tertiary-hover);--default-icon-color: var(--beacon-system-color-icon-tertiary);--disabled-bg: transparent;--disabled-icon: var(--beacon-system-color-icon-tertiary-inactive);--hover-bg: var(--override-icon-button-hover-bg, var(--default-hover-bg));--hover-icon: var(--override-icon-button-icon-color, var(--default-hover-icon));--icon-color: var(--override-icon-button-icon-color, var(--default-icon-color));border:0}`;
var D = Object.defineProperty, O = Object.getOwnPropertyDescriptor, T = (e, r, t, s) => {
  for (var o = O(r, t), a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (o = n(r, t, o) || o);
  return o && D(r, t, o), o;
};
const d = "beacon-icon-button", l = class l extends h(p).with(
  w
) {
  constructor() {
    super(...arguments), this.beaconTagName = d;
  }
  static get styles() {
    return [super.styles, $, this.IconButtonMotionStyles];
  }
  /**
   * Returns the closest beacon-popover parent to determine if the related data-metrics-location attribute should apply
   */
  get isPopoverChild() {
    return !!this.closest('[beacon-tag-name="beacon-popover"]');
  }
  applyDataMetricsLocation() {
    this.isPopoverChild && this.setAttribute(
      "data-metrics-location",
      g.DATA_METRICS_LOCATION_BODY
    );
  }
  /**
   * Render function for the default slot that is reused between link and button variants
   *
   * @returns {TemplateResult} slot wrapped in a visually-hidden span
   */
  renderDefaultSlot() {
    return i`<span class="visually-hidden"><slot></slot></span>`;
  }
  /**
   * Render function for beacon-button if link-href propety is passed in to support links as buttons
   *
   * @returns {TemplateResult} returns an `<a>` tag styled as a button
   */
  renderAnchorTag() {
    return i` <a
      part="icon-link"
      id="${c(this._passthroughs.attributes.get("id"))}"
      @click=${this.handleClick}
      href="${this.linkHref}"
      download="${c(this.linkDownload)}"
      target="${c(this.linkTarget)}"
      class="icon-button ${this.variant}"
      aria-disabled="${this.disabled}">
      ${this.renderDefaultSlot()}
      <span class="contents">
        <slot name="icon" @slotchange=${this.handleIconSlotchange}></slot>
      </span>
    </a>`;
  }
  /**
   * Render function for beacon-button as a `<button>` element
   *
   * @returns {TemplateResult} returns a `<button>` tag as the template
   */
  renderButtonTag() {
    return i`
      <button
        part="icon-button"
        id="${c(this._passthroughs.attributes.get("id"))}"
        @click=${this.handleClick}
        class="icon-button ${this.variant}"
        aria-disabled="${this.disabled}">
        ${this.renderDefaultSlot()}
        <span class="contents">
          <slot name="icon" @slotchange=${this.handleIconSlotchange}></slot>
        </span>
      </button>
    `;
  }
  render() {
    return i` ${u(
      this.linkHref,
      () => this.renderAnchorTag(),
      () => this.renderButtonTag()
    )}`;
  }
};
l.tagName = d;
let b = l;
T([
  m
], b.prototype, "applyDataMetricsLocation");
export {
  b as B,
  g as C
};
